import styles from "./verdicts.module.css";

/**
 * Shown when the audit set `recheck_recommended` — at least one ad was still
 * PENDING_REVIEW on Meta at audit time. Delivery status is live, so a pending
 * ad may flip to disapproved later; we recommend a re-audit in ~1h. This is a
 * heads-up, not a discrepancy (the run can still be `clean`).
 */
export function RecheckBanner() {
  return (
    <div className={styles.banner} role="status">
      <span className={styles.bannerIcon} aria-hidden="true">
        ⟳
      </span>
      <div className={styles.bannerBody}>
        <span className={styles.bannerTitle}>Re-audit recommended in ~1 hour</span>
        <p className={styles.bannerText}>
          Some ads were still pending Meta&apos;s review when this report was
          generated. Their delivery status can change — re-run the audit in about
          an hour to confirm nothing was disapproved after launch.
        </p>
      </div>
    </div>
  );
}
